import React, { createContext, useContext, useMemo, useState } from 'react';
import api from '../api/client';
import { useNavigate } from 'react-router-dom';

// util: parse JWT payload (base64url)
function parseJwt(token) {
  if (!token) return null;
  try {
    const base = token.split('.')[1];
    const b64 = base.replace(/-/g, '+').replace(/_/g, '/')
      .padEnd(Math.ceil(base.length / 4) * 4, '=');
    return JSON.parse(atob(b64));
  } catch {
    return null;
  }
}

function safeParse(json) {
  if (!json || json === 'undefined' || json === 'null') return null;
  try { return JSON.parse(json); } catch { return null; }
}

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // carrega do localStorage na inicialização
  const [token, setToken] = useState(() => {
    const t = localStorage.getItem('token');
    return !t || t === 'undefined' || t === 'null' ? null : t;
  });

  // user mínimo: { role }
  const [user, setUser] = useState(() => {
    const u = safeParse(localStorage.getItem('user'));
    if (u) return u;
    // fallback: tenta extrair do token
    const payload = parseJwt(localStorage.getItem('token'));
    if (payload?.role) return { role: payload.role };
    return null;
  });

  const navigate = useNavigate();

  const login = async (adm_login, pasw_senha) => {
    const { data } = await api.post('/api/api/login', { adm_login, pasw_senha });

    const t = data.token ?? '';
    localStorage.setItem('token', t);
    setToken(t);

    // preferimos role da resposta; se faltar, tenta do token
    let role = data.role;
    if (!role) {
      const payload = parseJwt(t);
      role = payload?.role;
    }
    const nextUser = role ? { role } : null;

    if (nextUser) {
      localStorage.setItem('user', JSON.stringify(nextUser));
    } else {
      localStorage.removeItem('user');
    }
    setUser(nextUser);

    navigate('/gerar');
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setToken(null);
    setUser(null);
    navigate('/login');
  };

  const value = useMemo(() => ({
    token, user, isAuth: !!token, login, logout
  }), [token, user]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
